<template>
    <div id="users">
        <status-message></status-message>
        <div v-if="statusUpdateMessage" class="success td-banner dismissible">
            <icon name="faCircleCheck" type="solid"></icon>
            <p>{{statusUpdateMessage}}</p>
            <icon name="faXmark" type="solid" @click="statusUpdateMessage = ''"></icon>
        </div>

        <transition name="modal">
            <modal v-if="showDoNotMarket" @close="closeDoNotMarket" hide-footer>
                <h4 class="td-h4">Set all users on the account to Do Not Market?</h4>
                <div class="actions mt-3">
                    <button class="danger td-btn icon-left ml-2" title="Do Not Market" @click.prevent="saveDoNotMarket"><icon class="icon" type="solid" name="faBan"></icon>Do Not Market</button>
                </div>
            </modal>
        </transition>

        <div class="users-invite my-2">
            <button @click="showInviteModal = true" class="td-btn secondary icon-left"><icon class="icon" type="solid" name="faPlus"></icon>Invite User</button>

            <button v-if="isCsrOrAdmin == true" @click="showAddModal = true" class="td-btn secondary-outlined icon-left ml-2"><icon class="icon" type="solid" name="faUserPlus"></icon>Add User</button>

            <button v-if="isCsrOrAdmin == true" @click="showDoNotMarket = true" class="td-btn danger icon-left ml-2 align-right"><icon class="icon" type="solid" name="faBan"></icon>Do Not Market Users</button>

            <button v-if="isCsrOrAdmin == true" @click="showPurgedUsersModal = true" class="td-btn secondary-outlined icon-left ml-2"><icon class="icon" type="solid" name="faUserTimes"></icon>Purged Users</button>
        </div>

        <div v-if="showInviteModal">
            <invite-user @close-invite="closeInvite" :account-name="accountSummary.n" :account-id="accountSummary.id"></invite-user>
        </div>

        <div v-if="showAddModal">
            <add-user-admin @close-add="closeAdd" :time-zones="timeZones" :account-summary="accountSummary"></add-user-admin>
        </div>

        <div v-if="showPurgedUsersModal">
            <purged-users @close-purged-users="closePurgedUsers" :account-number="accountSummary.ain"></purged-users>
        </div>

        <user-list :users="userList" @sort="sortList" :isAdmin="isAdmin"></user-list>

    </div>
    <div v-if="users && users.length < 1 && !isLoading" class="td-banner warning no-icon mt-2">
        <p>No users found.</p>
    </div>
</template>

<script>
    import script from './Users';
    export default script;
</script>

<style lang="less">
    @import './Users.less';
</style>